import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { JobTypeState } from '../../../store/jobType/job-type-state';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { NzModalService, NzModalRef } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';
import { SparepartsService } from '../../../service/spareparts.service';
@Component({
  selector: 'app-spare-info',
  templateUrl: './spare-info.component.html',
  styleUrls: ['./spare-info.component.less']
})
export class SpareInfoComponent implements OnInit {

  @Input() data: any; // data为null表示新增，否则表示修改
  spareTypes = [];
  unitTypes = [];
  validateForm: FormGroup;
  uploading = false;
  loading = false;
  unit = null;
  constructor(
    private fb: FormBuilder,
    private store: Store,
    private modalRef: NzModalRef,
    private modal: NzModalService,
    public message: NzMessageService,
    private dataService: SparepartsService
  ) { }

  ngOnInit(): void {
    console.log(this.data);
    this.initTypeTree(this.store.selectSnapshot<any[]>(JobTypeState));
    this.initUnitType();
    if (this.data == null) {
      this.validateForm = this.fb.group({
        spName: new FormControl({ value: null, disabled: false }, [Validators.required, Validators.maxLength(20)]),
        tid: new FormControl({ value: null, disabled: false }, Validators.required),
        unit: new FormControl({ value: null, disabled: false }, Validators.required),
        price: new FormControl({ value: null, disabled: false }, [ Validators.required, Validators.maxLength(7)]),
        spec: new FormControl({ value: null, disabled: false }, [ Validators.required, Validators.maxLength(20)]),
        safetyStock: new FormControl({ value: null, disabled: false }, [ Validators.required, Validators.maxLength(7)]),
      });
    } else {
      this.validateForm = this.fb.group({
        spName: new FormControl({ value: this.data.spName, disabled: false }, [Validators.required, Validators.maxLength(20)]),
        tid: new FormControl({ value: this.data.tid, disabled: false }, Validators.required),
        unit: new FormControl({ value: this.unit, disabled: false }, Validators.required),
        price: new FormControl({ value: this.data.price, disabled: false }, [ Validators.required, Validators.maxLength(7)]),
        spec: new FormControl({ value: this.data.spec, disabled: false }, [ Validators.required, Validators.maxLength(20)]),
        safetyStock: new FormControl({ value: this.data.safetyStock, disabled: false }, [ Validators.required, Validators.maxLength(7)]),
      });
    }
  }

  /**
   * 初始化 备件类型下拉框
   */
  initTypeTree(types: any[]) {
    for (const type of types) {
      const node = {
        title: type.skillName,
        value: type.skillId,
        key: type.skillId,
        isLeaf: true
      };
      if (type.parentId === 0) {
        this.spareTypes.push(node);
      }
    }
  }
  /**
   * 初始化备件单位下拉框
   */
  async initUnitType(){
    this.loading = true;
    const result = await this.dataService.queryUnitData('spare_unit');
    this.loading = false;
    if (result.code !== 200) {
      this.message.create('error', '查询备件单位信息失败!');
      return;
    } else {
      result.data.forEach(element => {
        if (this.data != null && this.data.unit === element.dictLabel){
          this.unit = element.dictValue;
        }
        const node = {
          title: element.dictLabel,
          value: element.dictValue,
          key: element.dictValue,
          isLeaf: true
        };
        this.unitTypes.push(node);
      });
      if (this.data != null){
        this.validateForm.patchValue({ unit : this.unit});
      }
    }
  }
  /**
   * 保存备件信息
   */
  async saveSparePartsData(){
    this.uploading = true;
    let result;
    if (this.data != null){
      this.validateForm.addControl('spNo', new FormControl({ value: this.data.spNo, disabled: false }, Validators.required));
      result = await this.dataService.editSparePartsData(this.validateForm.value);
    }else{
      result = await this.dataService.saveSparePartsData(this.validateForm.value);
    }
    this.uploading = false;
    if (result.code !== 200) {
      this.message.create('error', '保存备件信息失败!' + result.msg);
      return;
    } else {
      this.message.create('success', '保存备件信息成功!');
      this.modalRef.destroy('success');
    }

  }
  /**
   * 取消操作
   */
  cancleData(){
    this.modalRef.destroy('cancle');
  }
}
